export function logEvent(event: string, properties?: Record<string, any>) {
  if (import.meta.env.PUBLIC_STAGE !== 'production') return
  ;(window as any).posthog.capture(event, properties)
}
